<template>
    <div>
        <input :class="aspect.formFieldClass" type="password" v-model="fieldValue" :placeholder="placeholder" />
        <input type="text" v-model="fieldValue" @input="emitChange()">
    </div>
</template>

<script>
    export default {
        name: 'form-element-strong-password',
        props: {
            value:{type:String},
            validations: {type: Array, default: function(){ return []; }},
            placeholder: null,
            translations: {type: Object},
            aspect: {type: Object, default: function(){ return {}; }} 
        },
        data() {
          return {
            error: null,
            fieldValue: this.value,
            multipleValue: [],
            errorClasses: this.aspect.errorClasses,
            loaded: false,
            score: 0
          }
        },
        methods: {
            showScore(score){
                this.score = score;
            },
            emitChange(){
                this.$emit('input', this.fieldValue);
            },
        }
    }
</script>